<template>
    <div class="content">
        <ride-list/>
    </div>
</template>

<script>

    import {DASHBOARD} from "../router/routes";
    import RideList from '../components/ride/RideList'

    export default {
        name: DASHBOARD.name,
        components: {
            RideList
        },
        data() {
            return {}
        },
        methods: {},
        mounted: function () {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue